

































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import StatementModule from '@/store/modules/Statement';
import AuthModule from '@/store/modules/Auth';
import Table from '@/components/Table/Index.vue';
import DepositWithdrawData from '@/data/DepositWithdrawData';
import PaymentLogBody from '@/components/Table/PaymentLogBody.vue';
import Pagination from '@/components/Pagination.vue';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';

@Component({
  components: {
    Table,
    Pagination,
    PaymentLogBody,
  },
})
export default class PaymentLog extends Mixins(
  ToolMixin,
  ErrorHandleMixin,
  PaginationMixin,
) {
  StatementInstance = getModule(StatementModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  TableHead = DepositWithdrawData.TableHeadDetail;

  dataList: any = [];

  statement: any[] = [];

  statementCriteria = {
    username: this.AuthInstance.user.username,
    role: this.AuthInstance.user.role,
  };

  startDate = '';

  endDate = '';

  PaginationDetail = {
    page: 1,
    amount: 0,
    limit: 100,
  };

  sumFooter = 0;

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  };

  created() {
    this.fetchStatement();
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStart() {
    const _startDate = this.$moment(this.Period.start.date).startOf('day').toDate();
    this.startDate = _startDate;
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEnd() {
    const _endDate = this.$moment(this.Period.end.date).endOf('day').toDate();
    this.endDate = _endDate;
  }

  handleSubmit() {
    this.Period.start.date = this.startDate;
    this.Period.end.date = this.endDate;
    this.fetchStatement();
  }

  onSubmit() {
    this.fetchStatement();
  }

  async fetchStatement() {
    this.GeneralInstance.toggleLoading(true);
    const criteria = {
      ...this.statementCriteria,
      ...this.Period,
      current: this.PaginationDetail.page,
      size: this.PaginationDetail.limit,
    };
    const res = await this.StatementInstance.FetchStatementDetail(criteria);
    if (res.code) {
      this.checkError(res);
    } else {
      if (!['ADMIN', 'SUPERADMIN'].includes(this.AuthInstance.user.role)) {
        this.TableHead[0] = [...DepositWithdrawData.TableHeadDetail[0]]
          .filter((item: any) => !item.isAdmin);
      }
      this.dataList = res.logs;
      this.PaginationDetail.amount = res.pageAmount;
      this.sumFooter = res.footer;
    }
    this.GeneralInstance.toggleLoading(false);
  }

  changePage(i) {
    this.PaginationDetail.page = i;
    this.fetchStatement();
  }
}
